import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/奈尼芬多";
import { Soulmark } from "../../core/soulmark";
import { Skin } from "../../core/skin";

export class 奈尼芬多 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(264, "奈尼芬多", type.超能, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "1. 在艾迪星音乐殿堂的洗礼下，高贵典雅的奈尼芬多天生免疫固定伤害和百分比伤害，使用属性技能先制+1。",
            "2. 奈尼芬多登场后向对手施加<span style='color:rgb(150, 100, 255); font-weight: bold;'>反噬</span>效果，持续3回合。",
            "反噬：所有恢复体力的效果反转成体力流失（包括体力药剂、技能和魂印效果）",
            "3. 回合结束时，若奈尼芬多的体力低于1/3，则解除自身的异常状态和能力下降，并且下1回合触发<span style='color:rgb(150, 100, 255); font-weight: bold;'>临危一击</span>效果。",
            "临危一击：必定先出手，攻击技能威力为3倍。",
        ]);
        this.技能组 = [
            skill.寰宇劲乐,
            skill.五彩音域,
            skill.音符之藤,
            skill.幻想迷乐,
            skill.塞壬极乐,
        ];
        this.皮肤组.push(new Skin(262, "奈姬"));
        this.皮肤组.push(new Skin(263, "奈诺伊"));
    }
}
